import { jsx as r } from "react/jsx-runtime";
import i from "react";
import { PrimitiveSplitButton as m } from "./index.es12.js";
const a = i.forwardRef((t, o) => /* @__PURE__ */ r(m, { ...t, ref: o }));
export {
  a as SplitButton
};
//# sourceMappingURL=index.es11.js.map
